<template>
  <div>
    <v-dialog
      v-model="dialogDetail"
      persistent
      max-width="600px"
      class="container1"
      scrollable
      :key="keyComponent"
    >
      <v-card :height="innerHeight" class="overflow-auto">
        <div class="d-flex justify-center pa-2" style="position: relative">
          <div style="max-height: 240px">
            <img
              :src="item.image_url || item.image_path"
              style="
                max-width: 100%;
                max-height: 240px;
                width: auto;
                height: auto;
                border-radius: 10px;
                object-fit: contain;
                display: block;
                margin: 0 auto;
              "
              @error="onImageError($event, null, '')"
            />
          </div>

          <v-btn
            fab
            x-small
            style="z-index: 9999; position: absolute; top: 8px; right: 8px"
            class="ma-1 close-button"
            @click="$emit('close')"
            ><v-icon small :color="site.color">mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-title>
          <v-row>
            <v-col cols="9" class="py-0 align-center">
              <p class="text-subtitle-1 mb-0 truncate-text">
                {{ item.name }}
              </p>
              <v-chip
                x-small
                color="black"
                dark
                v-if="item.status == 'coming soon'"
              >
                {{ item.status }}
              </v-chip>
            </v-col>

            <v-col cols="3" class="py-0 d-flex align-center justify-end">
              <v-btn
                color="#fff"
                fab
                small
                elevation="0"
                class="outlined-fab"
                style="padding: 0px 8px"
              >
                <v-icon
                  v-if="!item.is_fevorite"
                  :color="site.color"
                  style="min-inline-size: -webkit-fill-available"
                  @click="$emit('addFavorite', item)"
                  >mdi-heart-outline</v-icon
                >
                <v-icon
                  v-if="item.is_fevorite"
                  :color="site.color"
                  style="min-inline-size: -webkit-fill-available"
                  @click="$emit('deleteFavorite', item)"
                  >mdi-cards-heart</v-icon
                >
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>

        <v-divider style="opacity: 1; color: black" class="ma-3"></v-divider>

        <v-card-text class="pb-2 pt-2">
          <v-row class="pb-2">
            <v-col cols="6" class="pa-0">
              <v-list-item class="pa-0">
                <v-list-item-avatar size="30" class="ml-3 mr-3">
                  <PointSymbol
                    v-if="
                      Array.isArray(item.point_used) &&
                      item.point_used.length > 0
                    "
                    :type="item.point_used[0].point_type_type"
                    :symbol="item.point_used[0].point_type_symbol"
                    :color="item.point_used[0].point_type_color"
                    :is_display="true"
                    :outlined_box="false"
                    :size="30"
                  />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title style="font-size: 10px">{{
                    $t("coinCost")
                  }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <div
                      v-if="
                        Array.isArray(item.point_used) &&
                        item.point_used.length > 0
                      "
                      class="text-truncate"
                      style="width: 100%"
                    >
                      {{ item.point_used[0].point | commaPoint }}
                      {{ item.point_used[0].point_type_name }}
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="6" class="pa-0">
              <v-list-item class="pa-0">
                <v-list-item-avatar size="30" class="ml-3 mr-3">
                  <v-img src="@/assets/images/package.png"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title style="font-size: 10px">{{
                    $t("availableStock")
                  }}</v-list-item-title>
                  <v-list-item-subtitle>{{
                    item.type == "lucky draw"
                      ? "-"
                      : item.number_of_items | commaPoint
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <div v-if="item.status == 'coming soon'">
            <p class="text-subtitle-2 mb-0 font-weight-bold mt-2">
              {{ $t("rewardStartDate") }}
            </p>
            <p>{{ item.start_date | convertDate }}</p>
          </div>
          <div v-else>
            <p class="text-subtitle-2 mb-0 font-weight-bold mt-2">
              {{ $t("rewardExpiredDate") }}
            </p>
            <p>{{ item.expires_at | convertDate }}</p>
          </div>

          <p class="text-subtitle-2 mb-0 font-weight-bold">
            {{ $t("detail") }}
          </p>
          <div style="height: calc(100% - 130px)">
            <div
              class="ql-editor"
              style="max-height: fit-content"
              v-html="formatHtmlDetail(item.detail)"
            ></div>
          </div>
        </v-card-text>

        <v-card-actions
          class="d-block"
          v-if="item.status == 'active' && item.number_of_items > 0"
        >
          <v-list-item class="grow" style="display: -webkit-box">
            <v-row align="start" justify="space-between">
              <v-col cols="6" class="pl-0 pr-1 d-flex align-start">
                <v-card
                  class="rounded-lg d-flex"
                  outlined
                  width="100%"
                  height="36"
                >
                  <v-col
                    cols="3"
                    class="py-0 d-flex justify-center align-center"
                  >
                    <v-icon
                      dense
                      :color="site.color"
                      @click="decrementQuantity"
                      :disabled="this.quantity <= 1"
                      >mdi-minus</v-icon
                    >
                  </v-col>
                  <v-col cols="6" class="pa-0">
                    <input
                      class="quantity"
                      style="
                        max-width: 100%;
                        height: 36px;
                        text-align: center;
                        border-left: 1px solid #e0e0e0;
                        border-right: 1px solid #e0e0e0;
                        border-top: none;
                        border-bottom: none;
                      "
                      v-model="quantity"
                      readonly
                    />
                  </v-col>
                  <v-col
                    cols="3"
                    class="py-0 d-flex justify-center align-center"
                  >
                    <v-icon
                      dense
                      :color="site.color"
                      @click="incrementQuantity"
                      :disabled="quantity >= item.number_of_items"
                      >mdi-plus</v-icon
                    >
                  </v-col>
                </v-card>
              </v-col>
              <v-col cols="6" class="pl-1 pr-0">
                <v-btn
                  :color="site.color"
                  class="rounded-lg white--text text-capitalize"
                  @click="$emit('redeemRewardFinal', quantity)"
                  width="100%"
                >
                  {{ $t("redeemPoint") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-list-item>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import PointSymbol from "../point/point-symbol.vue";
import { formatHtmlDetailDefault } from "../../config/general-function.js";

export default {
  components: { PointSymbol },
  props: ["item", "dialogDetail", "keyComponent", "site"],

  data() {
    return {
      quantity: 1,
    };
  },

  watch: {
    dialogDetail(value) {
      if (value) {
        this.quantity = 1;
      }
    },
  },

  methods: {
    onImageError(event, item, key) {
      if (item && item[key]) {
        item[key] = "";
      } else {
        event.target.style.display = "none";
      }
    },
    incrementQuantity() {
      if (this.quantity < this.item.number_of_items) {
        this.quantity = this.quantity + 1;
      }
    },
    decrementQuantity() {
      if (this.quantity > 1) {
        this.quantity = this.quantity - 1;
      }
    },
    formatHtmlDetail(value) {
      return formatHtmlDetailDefault(value);
    },
  },
  computed: {
    innerHeight() {
      const height = window.innerHeight;
      return height - 120;
    },
  },
  filters: {
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    convertDate(value) {
      if (!value) return "-";
      return moment(value).format("D MMMM YYYY");
    },
  },
};
</script>

<style lang="scss" scoped>
.truncate-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 100%;
}
</style>
